import { createContext } from 'react';
import { AuthContextValue } from './types';

const AuthContext = createContext<AuthContextValue>({} as AuthContextValue);
AuthContext.displayName = 'AuthContext';

export default AuthContext;
